import { defaultDarkTheme2023 } from "./defaultDarkTheme2023";
import { defaultLightTheme2023 } from "./defaultLightTheme2023";
const themes = {
    // @ts-expect-error `ThemeReturn` does not account for `defaultDarkTheme2023`
    darkTheme2023: defaultDarkTheme2023,
    lightTheme2023: defaultLightTheme2023,
};
export const getThemeByName = (userTheme) => {
    if (!themes[userTheme.themeName]) {
        return themes.lightTheme2023(userTheme);
    }
    return themes[userTheme.themeName](userTheme);
};
